class BonuscardBonnachtrag extends HTMLElement {
    connectedCallback() {
        this.setFormDateRequirements();
        this.initScannerListener();
        this.initKassennummerInfoOverlay();
    }

    setFormDateRequirements() {
        const today = new Date();
        this.dateInput.max = getHtmlFormValidDateString(today);
        this.dateInput.min = getHtmlFormValidDateString(calculateDateTwoWeeksBefore(today));
    }

    initScannerListener() {
        document.addEventListener("successful-scan", (event) => this.handleBonuscardScanResult(event))
    }

    handleBonuscardScanResult(event) {
        const bonuscardInput = this.querySelector("#bonuscard");
        bonuscardInput.value = event.detail.scanResult;
    }

    initKassennummerInfoOverlay() {
        const overlay = this.querySelector("#kassennummer-info-overlay");
        this.querySelector("[interaction=kassennummer-info-overlay-oeffnen]")?.addEventListener("click", () => overlay.showModal());
        this.querySelector("[interaction=kassennummer-info-schliessen]")?.addEventListener("click", () => overlay.close());
    }

    get dateInput() {
        return this.querySelector("input[type=date]");
    }
}

function calculateDateTwoWeeksBefore(date) {
    const twoWeeksInMs = 12096e5;
    return new Date(date - twoWeeksInMs);
}

function getHtmlFormValidDateString(date) {
    return date.toISOString().split("T")[0];
}

if (!customElements.get("bonuscard-bonnachtrag")) {
    customElements.define("bonuscard-bonnachtrag", BonuscardBonnachtrag);
}